/**
 * List prices for the NON-Apple channels — Stripe (syqel.art, the direct desktop build, the Microsoft
 * Store build) and Google Play — in USD. The one place these numbers live in the web app: the Stripe
 * button labels, the "save N%" badge, the Legal page and the analytics `PLANS` all derive from it.
 * Apple is priced separately ($10 / $100) and its numbers come live from StoreKit, never from here.
 * Existing subscribers keep the price they signed up at — Stripe and Play bill them on their old price
 * objects / price cohort; nothing in this repo migrates anyone.
 */
export const PRICE_USD = { monthly: 10, annual: 79 } as const

/** Whole-percent saving of an annual plan vs twelve months of the monthly one (0 when unknown). */
export function annualSavingsPct(monthly: number, annual: number): number {
  return monthly > 0 ? Math.round((1 - annual / (monthly * 12)) * 100) : 0
}
